import {CopyToClipboardIconButton} from '@github-ui/copy-to-clipboard/IconButton'

import type {PanelArtifact} from './ArtifactPanelContent'

type ArtifactCopyButtonProps = {
  artifact: PanelArtifact | null
}

export function ArtifactCopyButton({artifact}: ArtifactCopyButtonProps) {
  if (!artifact?.body) return null

  return <CopyToClipboardIconButton textToCopy={artifact.body} ariaLabel="Copy artifact content" />
}
